import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { UniversalTime } from "@biteinc/helpers-universal";
//#region src/utils/menu_cover_promo_utils.ts
var menu_cover_promo_utils_exports = /* @__PURE__ */ __exportAll({ isEnabledAndAvailable: () => isEnabledAndAvailable });
function isEnabledAndAvailable(data, availabilityTime, timezone) {
	if (!data.isEnabled) return false;
	if (data.availability?.dateRanges?.length) {
		if (!data.availability.dateRanges.find(({ to, from }) => {
			return from <= availabilityTime && availabilityTime < to;
		})) return false;
	}
	if (data.availability?.daySchedules?.length) {
		const todayStart = UniversalTime.getStartOfDayFromUnixTime(availabilityTime, timezone);
		const todayWeekdayName = UniversalTime.getWeekdayFromUnixTime(availabilityTime, timezone);
		const currentDaySchedule = data.availability.daySchedules.find(({ weekday }) => {
			return weekday === todayWeekdayName;
		});
		if (!currentDaySchedule) return false;
		return currentDaySchedule.schedules.some(({ from, to }) => {
			const { hours: fromHour, minutes: fromMinute } = from;
			const { hours: toHour, minutes: toMinute } = to;
			const fromTime = fromHour * UniversalTime.HOUR + fromMinute * UniversalTime.MINUTE + todayStart;
			const toTime = toHour * UniversalTime.HOUR + toMinute * UniversalTime.MINUTE + todayStart;
			return availabilityTime >= fromTime && availabilityTime <= toTime;
		});
	}
	return true;
}
//#endregion
export { isEnabledAndAvailable, menu_cover_promo_utils_exports };

//# sourceMappingURL=menu_cover_promo_utils.js.map